/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Share_TitleInputs */

const en_story_share_title = /** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share a Story`)
};

const es_story_share_title = /** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartir una Historia`)
};

const fr_story_share_title = /** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partager une Story`)
};

const de_story_share_title = /** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Story teilen`)
};

const id_story_share_title = /** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan Cerita`)
};

/** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */
const ja_story_share_title = en_story_share_title;

/** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */
const zh_story_share_title = en_story_share_title;

/** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */
const ar_story_share_title = en_story_share_title;

/** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */
const it_story_share_title = en_story_share_title;

/** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */
const ru_story_share_title = en_story_share_title;

/** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */
const pt_story_share_title = en_story_share_title;

/** @type {(inputs: Story_Share_TitleInputs) => LocalizedString} */
const ko_story_share_title = en_story_share_title;

/**
* | output |
* | --- |
* | "Share a Story" |
*
* @param {Story_Share_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_share_title = /** @type {((inputs?: Story_Share_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Share_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_share_title(inputs)
	if (locale === "es") return es_story_share_title(inputs)
	if (locale === "fr") return fr_story_share_title(inputs)
	if (locale === "de") return de_story_share_title(inputs)
	if (locale === "ja") return ja_story_share_title(inputs)
	if (locale === "zh") return zh_story_share_title(inputs)
	if (locale === "ar") return ar_story_share_title(inputs)
	if (locale === "id") return id_story_share_title(inputs)
	if (locale === "it") return it_story_share_title(inputs)
	if (locale === "ru") return ru_story_share_title(inputs)
	if (locale === "pt") return pt_story_share_title(inputs)
	return ko_story_share_title(inputs)
});